import AddressConfig from '@/models/interfaces/Address';
import CountryRepository from '@/repositories/CountryRepository';

export function buildAddressValidationString(address: AddressConfig) {
    if (!address) {
        return '';
    }

    const country = address.country?.id ?? address.country;
    const countryId = typeof country === 'string' ? country.split('|')[0] : country;
    const countryName = countryId ? CountryRepository.getById(countryId)?.name : '';
    const postalCodeAndCity = [address.poNumber, address.city].filter(Boolean).join(' ');

    return [address.streetNameAndNumber, postalCodeAndCity, countryName].filter(Boolean).join(', ');
}

export function openValidatedAddressInGoogleMaps(address: AddressConfig) {
    if (!address || address.validated !== true) {
        return;
    }

    const addressString = buildAddressValidationString(address);

    if (!addressString) {
        return;
    }

    const googleMapsUrl = new URL('https://www.google.com/maps/search/');
    googleMapsUrl.searchParams.set('api', '1');
    googleMapsUrl.searchParams.set('query', addressString);

    const openedWindow = window.open(googleMapsUrl.toString(), '_blank', 'noopener,noreferrer');
    if (openedWindow) {
        openedWindow.opener = null;
    }
}
